module.exports = __webpack_public_path__ + "static/media/nSk38NcGLx.1877c879.jpg";